import { CalendarDirectiveModule } from '@b2b/common/directives/calendar/calendar';
import { LoadCssResolver, LoadScriptResolver } from '@b2b/common/resolvers';
import uiRouter, { StateProvider } from '@uirouter/angularjs';
import angular from 'angular';
import { ProgramsCalendarEventView } from './event/event';

export const ProgramsCalendarView = angular
  .module('acme.view.application.programs.calendar', [
    uiRouter,
    'ui.bootstrap',
    CalendarDirectiveModule,
    ProgramsCalendarEventView,
    'acme.view.application.programs.calendar.controllers',
  ])
  .config(function config($stateProvider: StateProvider) {
    $stateProvider.state({
      name: 'application.programs.calendar',
      url: '/calendar',
      abstract: true,
      views: {
        'subview-main': {
          controller: 'CalendarController',
          templateUrl: 'views/application/views/programs/calendar/calendar.tpl.html',
        },
      },
      resolve: {
        jqueryUI: LoadScriptResolver({ id: 'jquery-ui', url: '/assets/jquery-ui.custom.min.js' }),
        fullcalendar: LoadScriptResolver({ id: 'fullcalendar', url: '/assets/fullcalendar.js' }),
        istevenMultiselectCss: LoadCssResolver({ id: 'isteven-multi-select', url: '/assets/isteven-multi-select.css' }),
      },
    });
  }).name;
